import { CommandItem } from "../../../common/Chat/types";
import {
  CasesValue,
  TAiScoringRequest,
  TAiScoringValidationCase,
  TAiTipRequest,
  TCaseAgentHarness,
  TCaseCommonInfo,
  TCaseFieldKeys,
  TCaseSolutionPrompt,
} from "../../../services/api/instances/casesApi/types";
import { TFeasibilityStatus } from "../types";

export const CASES_TABLE_URL = "https://instapp-i2048-scoring-table.mlhub.ru";

export const FEASIBILITY_STATUS: TFeasibilityStatus[] = [
  "less",
  "more",
  "new",
  "unknown",
];

export const INITIAL_CASE_SOLUTION: TCaseSolutionPrompt = {
  solution_type: "unknown",
  next_steps: "",
  initial_prompt: "",
};

export const INITIAL_AI_SCORING_OBJECT: TAiScoringValidationCase = {
  task_description: {
    formulation: "",
    status: "unknown",
    reason: null,
    suggested_formulation: null,
    clarifying_question: null,
    kind_mismatch: null,
    mismatch_hint: null,
  },
  input_artifact: {
    formulation: "",
    status: "unknown",
    reason: null,
    suggested_formulation: null,
    clarifying_question: null,
    kind_mismatch: null,
    mismatch_hint: null,
  },
  output_artifact: {
    formulation: "",
    status: "unknown",
    reason: null,
    suggested_formulation: null,
    clarifying_question: null,
    kind_mismatch: null,
    mismatch_hint: null,
  },
  consumer: {
    formulation: "",
    status: "unknown",
    reason: null,
    suggested_formulation: null,
    clarifying_question: null,
    kind_mismatch: null,
    mismatch_hint: null,
  },
  knowledge: {
    formulation: "",
    status: "unknown",
    reason: null,
    suggested_formulation: null,
    clarifying_question: null,
    kind_mismatch: null,
    mismatch_hint: null,
  },
  output_attributes: {
    formulation: "",
    status: "unknown",
    reason: null,
    suggested_formulation: null,
    clarifying_question: null,
    kind_mismatch: null,
    mismatch_hint: null,
  },
  skills: {
    formulation: "",
    status: "unknown",
    reason: null,
    suggested_formulation: null,
    clarifying_question: null,
    kind_mismatch: null,
    mismatch_hint: null,
  },
  summary: {
    case_status: "unknown",
    project_summary: "",
    case_summary: "",
    chain_coherence: "",
    chain_comment: "",
    score_short: "",
  },
};

export const INITIAL_CASE_AGENT_HARNESS: TCaseAgentHarness = {
  case_agent_services: {
    external_services: "",
  },
  case_agent_memory: {
    memory: "",
  },
  case_agent_skills: {
    agent_skills: "",
  },
  case_agent_info: {
    interaction_interfaces: "",
  },
  case_agent_tools: {
    tools: "",
  },
};

export const INITIAL_CASE_INFO: CasesValue = {
  case_object: {
    case_info: {
      name: "",
      task_description: "",
    },
    case_artifacts_chain: {
      input_artifact: "",
      output_artifact: "",
      consumer: "",
    },
    case_transform_method: {
      knowledge: "",
      output_attributes: "",
      skills: "",
    },
    case_metadata: {
      feasibility: "",
      personal_effectiveness: false,
    },
    case_expert_scoring: {
      expert_scoring: "",
    },
  },
  agent_harness: INITIAL_CASE_AGENT_HARNESS,
  case_comments: [],
  ai_scoring: INITIAL_AI_SCORING_OBJECT,
  solution_prompt: INITIAL_CASE_SOLUTION,
  metadata: {
    isLegacyObject: false,
    has_new_agent_schema: true,
  },
};

export const EMPTY_CASE_COMMON_INFO: TCaseCommonInfo[] = [];

export const CASE_FIELD_TOOLTIP: Record<TCaseFieldKeys, string> = {
  case_info:
    "Название проекта - краткое описание решаемой с помощью ИИ-инструмента задачи",
  task_description: "Описание кейса",
  input_artifact: `Артефакт на входе - существительное, которое отвечает на вопрос "что", описывающее документ, объект (например то, что можно распечатать), параметр из какой-нибудь системы и т.п., поступающий(-ие) на вход ИИ инструмента для решения задачи`,
  output_artifact: `Артефакт на выходе - существительное, которое отвечает на вопрос "что", описывающее документ, объект (например то, что можно распечатать), параметр из какой-нибудь системы и т.п., выдаваемый ИИ инструментом в результате своей работы`,
  consumer: `Потребитель - машина или человек (должность, отдел), кто использует Артефакт на выходе из ИИ инструмента для своей работы, принятия решения или следующего шага процесса.`,
  knowledge: `Знания - зафиксированные или неявные представления о предметной области, правилах,связях (интеграциях с другими системами) и критериях, нужные для преобразования входящего артефакта в исходящий`,
  output_attributes:
    "Перечислите обязательные атрибуты Выходного артефакта, определяющие корректность артефакта для потребителя",
  skills: `Навыки - способ применения знаний на практике: как человек преобразует входящий артефакт в исходящий.`,
  feasibility: `Экономический эффект:
less — сделать с меньшими затратами (оптимизация производства): меньше времени, ошибок, стоимости, потерь, ручного труда;
more — сделать больше или лучше в текущем процессе: больше скорости, качества, пропускной способности, конверсии, точности;
new — получить новую ценность, которая раньше была недоступна: новый продукт, новый сервис, новый уровень управляемости или новое решение.`,
};

export const CASE_FIELD_ROWS: Record<TCaseFieldKeys, number> = {
  name: 1,
  task_description: 3,
  input_artifact: 3,
  output_artifact: 3,
  consumer: 3,
  knowledge: 3,
  output_attributes: 3,
  skills: 3,
  feasibility: 1,
};

export const EMPTY_AI_SCORING_DATA: TAiScoringRequest = {
  task_description: "",
  input_artifact: "",
  output_artifact: "",
  consumer: "",
  knowledge: "",
  output_attributes: "",
  skills: "",
};

export const EMPTY_AI_TIP_DATA: TAiTipRequest = {
  task_description: "",
  input_artifact: "",
  output_artifact: "",
  consumer: "",
  knowledge: "",
  output_attributes: "",
  skills: "",
  field: "",
  current: "",
};

export const CASE_EXAMPLE_LABELS = {
  title: "Название кейса",
  input: "Артефакт на входе",
  output: "Артефакт на выходе",
  consumer: "Потребитель",
  comment: "Комментарии",
  summary: "Описание кейса",
};
